import React from "react";
import styled from "styled-components";
import drivingGif from "../PhotosGallery/photo5.jpg"; // Ensure this path is correct

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  min-height: 100vh; // Ensure it takes full height
  color: darkgoldenrod;

  position: relative;
  text-align: center; // Center text for better readability

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const GIFContainer = styled.div`
  width: 30%; // Ensure it takes up 90% of the screen width
  height: auto;

  display: flex;
  justify-content: center;
  align-items: center; // Center the image

  & img {
    max-width: 100%;
    height: auto;
    filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.7));
    border-radius: 15px; // Rounded corners
    opacity: 0.95; // Slight transparency
    object-fit: cover; // Cover the area without distortion
    animation: img-shine 3s infinite alternate; // Keep animation for small screens

    @keyframes img-shine {
      0% {
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 10px rgba(212, 175, 55, 0.7);
      }
      100% {
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 20px rgba(212, 175, 55, 0.9), 0 0 30px rgba(212, 175, 55, 0.8);
      }
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 20px; // Add spacing below on mobile
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90%; // Limit width on small screens
  padding: 10px; // Adjust padding for mobile

  @media (max-width: 768px) {
    padding: 5px; // Further reduce padding on mobile
  }
`;

const WelcomeText = styled.h1`
  font-size: 2.5rem;
  color: #d4af37; // Gold color
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.8rem; // Smaller font size on mobile
  }
`;

const DescriptionText = styled.p`
  font-size: 1.2rem;
  line-height: 1.5;
  color: #d4af37; // Gold color
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 1rem; // Smaller text for mobile
  }
`;

const RegistrationLinkContainer = styled.div`
  display: inline-block;
  padding: 12px 30px;
  border-radius: 15px;
  background: linear-gradient(45deg, #b8860b, #d4af37); // Gold gradient
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 20px; // Add margin for spacing

  transition: transform 0.3s ease, box-shadow 0.3s ease; // Smooth transitions

  &:hover {
    transform: scale(1.05); // Slight enlargement on hover
  }

  @media (max-width: 768px) {
    width: 90%; // Full width on smaller screens
    font-size: 1rem; // Smaller font size on mobile
  }
`;

const LinkText = styled.a`
  color: darkgoldenrod;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Home: React.FC = () => {
  return (
    <HomeContainer>
      <GIFContainer>
        <img src={drivingGif} alt="Driving School Animation" />
      </GIFContainer>
      <TextContainer>
        <WelcomeText>Welkom bij Best Rijschool!</WelcomeText>
        <DescriptionText>
          Leren rijden is meer dan alleen een vaardigheid – het is een reis naar
          vrijheid, zelfvertrouwen en onafhankelijkheid. Bij{" "}
          <strong>Best Rijschool</strong>, leren we je niet alleen de
          verkeersregels, we begeleiden je om een zelfverzekerde
          bestuurder te worden die klaar is om elke weg met gemak en veilig te
          besturen.
          <br />
          <br />
          Of je nu nieuw bent met rijden of je vaardigheden wilt verbeteren, onze
          ervaren instructeurs staan ​​klaar om je bij elke stap te
          ondersteunen. Met flexibele planning, persoonlijke lessen en een
          toewijding aan jouw veiligheid, is <strong>Best Rijschool</strong> de
          plek waar je in je eigen tempo kunt leren, in een vriendelijke en
          veilige omgeving.
          <br />
          <br />
          Laten we samen de weg op gaan – jouw reis naar vrijheid begint hier!
        </DescriptionText>
      </TextContainer>
      <RegistrationLinkContainer>
        Om je in te schrijven, klik{" "}
        <LinkText
          href="https://www.startmetjerijbewijs.nl/jangin-shekho/inschrijven"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>
            <i>HIER</i>
          </strong>
        </LinkText>
      </RegistrationLinkContainer>
    </HomeContainer>
  );
};

export default Home;
